import axios from 'axios';
import Cookies from 'js-cookie';

import { getAuthHeader } from './userInfo-actions';
import { courseDataActions } from './course-slice';

const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_COOKIE_CONSTANT}`
);

export const getCourseInfo = idCourse => {
  return async dispatch => {
    let courseData = await axios.get(
      `${process.env.REACT_APP_API_PATH_MAYAHII_USER_DATA}/course/user/static`,
      {
        params: {
          idCourse
        },
        headers: getAuthHeader()
      }
    );

    if (courseData.status === 200) {
      dispatch(
        courseDataActions.info({
          info: courseData.data
        })
      );
    }
  };
};

export const getCourseAditionalInfo = idCourse => {
  return async dispatch => {
    let courseAditionalData = await axios.get(
      `${process.env.REACT_APP_API_PATH_COURSE}/course`,
      {
        params: {
          idCourse
        },
        headers: getAuthHeader()
      }
    );

    if (courseAditionalData.status === 200) {
      dispatch(
        courseDataActions.aditionalInfo({
          aditionalInfo: courseAditionalData.data
        })
      );
    }
  };
};

export const getUsersInCourse = idCourse => {
  return async dispatch => {
    let usersInCourselData = await axios.get(
      `${process.env.REACT_APP_API_PATH_STATISTIC}/stat/course/user/progress`,
      {
        params: {
          idCourse
        },
        headers: getAuthHeader()
      }
    );

    if (usersInCourselData.status === 200) {
      dispatch(
        courseDataActions.usersInCourse({
          usersInCourse: usersInCourselData.data.progress
        })
      );
    }
  };
};

export const getAccesCourse = (idCourse, idEmisorOriginal) => {
  return async dispatch => {
    let accesCourse = await axios.get(
      `${process.env.REACT_APP_API_PATH_MAYAHII_USER_DATA}/course/access`,
      {
        params: {
          idCourse,
          idEmisorOriginal
        },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (accesCourse.status === 200) {
      dispatch(
        courseDataActions.accessCourse({
          access: accesCourse.data
        })
      );
    }
  };
};

export const getUserTrackByCourse = idCourse => {
  return async dispatch => {
    let userTrack = await axios.get(
      `${process.env.REACT_APP_API_PATH_MAYAHII_USER_DATA}/course/user/track`,
      {
        params: {
          idCourse
        },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (userTrack.status === 200) {
      dispatch(
        courseDataActions.userTrack({
          track: userTrack.data
        })
      );
    }
  };
};

//TODO cambiar por REACT_APP_API_PATH_STATISTIC cuando se lance a prod
export const getUserAditionalTrackCourse = idCourse => {
  return async dispatch => {
    let userAditionalTrack = await axios.get(
      `${process.env.REACT_APP_API_PATH_STATISTIC}/stat/course/track`,
      {
        params: {
          idCourse
        },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (userAditionalTrack.status === 200) {
      dispatch(
        courseDataActions.userAditionalTrack({
          aditionalTrack: userAditionalTrack.data.response
        })
      );
    }
  };
};

export const getLessonsByCourse = idCourse => {
  return async dispatch => {
    let lessonsCourse = await axios.get(
      `${process.env.REACT_APP_API_PATH_LESSON}/lesson`,
      {
        params: {
          idCourse
        },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (lessonsCourse.status === 200) {
      dispatch(
        courseDataActions.lessonsCourse({
          lessonsCourse: lessonsCourse.data.lstLessonVO
        })
      );
    }
  };
};

export const getMissingActivities = idCourse => {
  return async dispatch => {
    let missingUserActivities = await axios.post(
      `${process.env.REACT_APP_API_PATH_LESSON}/lesson/progress`,
      { idCourse },
      { headers: getAuthHeader(jwtCookie) }
    );
    if (missingUserActivities.status === 200) {
      dispatch(
        courseDataActions.missingActivities({
          missingActivities: missingUserActivities.data
        })
      );
    }
  };
};

export const getCourseReviews = idCourse => {
  return async dispatch => {
    let courseReviews = await axios.get(
      `${process.env.REACT_APP_API_PATH_COURSE}/course/reviews`,
      {
        params: {
          idCourse
        },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (courseReviews.status === 200) {
      dispatch(
        courseDataActions.courseReviews({
          courseReviews: courseReviews.data.reviews
        })
      );
    }
  };
};

export const ratingCourse = (idCourse, rate, comment) => {
  return async dispatch => {
    let userReview = await axios.post(
      `${process.env.REACT_APP_API_PATH_COURSE_ADDITIONAL}/course/review`,
      { idCourse, rate, comment },
      { headers: getAuthHeader(jwtCookie) }
    );

    if (userReview.status === 200) {
      dispatch(
        courseDataActions.userReview({
          userReview: userReview.data.review
        })
      );
    }
  };
};

export const getDegree = idCourse => {
  return async dispatch => {
    let userDegree = await axios.get(
      `${process.env.REACT_APP_API_PATH_DEGREES}/diploma/available`,
      {
        params: {
          idCourse
        },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (userDegree.status === 200) {
      dispatch(
        courseDataActions.userDegree({
          userDegree: userDegree.data.diploma
        })
      );
    }
  };
};

export const getTrailerCourseInfo = (academyId, courseId) => {
  return async dispatch => {
    let trailerCourse = await axios.get(
      `${process.env.REACT_APP_API_PATH_VIDEO}/video/trailer`,
      {
        params: {
          academyId,
          courseId
        },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (trailerCourse.status === 200) {
      dispatch(
        courseDataActions.trailerCourse({
          trailerCourse: trailerCourse.data
        })
      );
    }
  };
};

export function shareSocialMedia(diplomaUrl, ip, type, origin) {
  const request = axios.post(
    `${process.env.REACT_APP_API_PATH_SHARE}/analytics/social/share`,
    { diplomaUrl, ip, type, origin },
    {
      headers: getAuthHeader()
    }
  );
  return {
    type: 'SHARE_SOCIAL_MEDIA',
    payload: request
  };
}
